/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StatementPeriod = {
    CurrentMonth: 'CurrentMonth',
    YearToDate: 'YearToDate',
    MultiYear: 'MultiYear',
    All: 'All'
} as const;
export type StatementPeriod = typeof StatementPeriod[keyof typeof StatementPeriod];


export function instanceOfStatementPeriod(value: any): boolean {
    for (const key in StatementPeriod) {
        if (Object.prototype.hasOwnProperty.call(StatementPeriod, key)) {
            if (StatementPeriod[key as keyof typeof StatementPeriod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatementPeriodFromJSON(json: any): StatementPeriod {
    return StatementPeriodFromJSONTyped(json, false);
}

export function StatementPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementPeriod {
    return json as StatementPeriod;
}

export function StatementPeriodToJSON(value?: StatementPeriod | null): any {
    return value as any;
}

export function StatementPeriodToJSONTyped(value: any, ignoreDiscriminator: boolean): StatementPeriod {
    return value as StatementPeriod;
}

